import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'hsc-maintenance-credit',
  imports: [CommonModule],
  template: `
    <div class="bg-medium-blue px-12 py-0 pb-0">
      <div class="bolt-container">
        <div class="g-0 flex flex-row">
          <div class="flex !w-1/2 w-full flex-col justify-center !py-12.5 !pr-12">
            <div class="bg-medium-blue">
              <img src="/icons/shield-icon.svg" alt="shield-icon" class="mx-auto mb-1.5 block" />
              <h2
                class="bolt-heading-sm bolt-serif mb-4 text-center text-[26px] leading-[32px] font-semibold text-white"
              >
                Get reimbursed for preventative maintenance
              </h2>
              <p
                class="font-sans-serif !mb-0 text-left text-[14px] leading-[20px] font-normal tracking-[0.5px] text-white"
              >
                Get a $150 reimbursement every 12 months for a professional HVAC system tune-up, dryer vent cleaning,
                gutter cleaning, chimney sweep or water heater maintenance.
              </p>
            </div>
          </div>
          <div class="flex w-1/2 items-stretch justify-center">
            <img src="/images/let-us-help-image.png" alt="let-us-help-image" class="block h-full w-auto object-cover" />
          </div>
        </div>
      </div>
    </div>
  `,
})
export class MaintenanceCredit {}
